import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
export const getDriversLocation = createAsyncThunk('appDriversLocation/getDriversLocation', async () => {
    //
    const response = await axios.post(' https://api.zasway.com:8443/Driver/GetTableSummaryDriverLocation', { mode: 'cors' })
    //
    return response.data
})

export const appDriversLocationSlice = createSlice({
    name: 'appDriversLocation',
    initialState: {
        data: [],
        allData: []

    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getDriversLocation.fulfilled, (state, action) => {
                state.allData = action.payload.allData
                state.data = action.payload.data
            })
    }
})
export default appDriversLocationSlice.reducer